// removed by extract-text-webpack-plugin
module.exports = {"articleHeader":"styles__articleHeader___mPuDK"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/articleHeader/styles.css
// module id = mU/R
// module chunks = 3